import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchFeedback(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/game-feedback', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
